import { useImage } from "@wemade-vsf/composables";
import { useProduct } from "../composables/useProduct";
import { usePriceRequest } from "../composables/usePriceRequest";
import { useCustomerPricing } from "../composables/useCustomerPricing";
import {
  getName,
  getProductThumbnailImage
} from "../getters/productGetters";
import { useContext } from "@nuxtjs/composition-api";
const prepareCardProduct = (product) => {
  const { $fc, localeRoute } = useContext();
  const { getMagentoImage } = useImage();
  const { getProductPath } = useProduct();
  const { getPriceForProduct, displayPricesIncludingTax, showCartButtonForProduct, showPriceForProduct } = useCustomerPricing();
  const { isQuoteProduct, showPriceOnQuoteProduct } = usePriceRequest();
  const price = getPriceForProduct(product);
  const priceProps = {
    price,
    regularPrice: $fc(price.regular),
    specialPrice: price.special && $fc(price.special),
    maximumPrice: price.maximum && $fc(price.maximum)
  };
  const productAttributes = product.wm_custom_attributes ? product.wm_custom_attributes.reduce((acc, attribute) => {
    acc[attribute.attribute_code] = attribute;
    return acc;
  }, {}) : {};
  const isQuotable = isQuoteProduct(product, productAttributes);
  const showCartButton = isQuotable ? false : showCartButtonForProduct(product);
  const showPrice = (isQuotable ? showPriceOnQuoteProduct : true) && showPriceForProduct(product);
  const cardProps = {
    title: getName(product),
    link: localeRoute(getProductPath(product)),
    imageTag: "nuxt-img",
    nuxtImgConfig: { fit: "inside" },
    image: getMagentoImage(getProductThumbnailImage(product)),
    ...priceProps,
    priceIncludesTax: displayPricesIncludingTax.value,
    showCartButton,
    showPrice,
    isQuoteProduct: isQuotable,
    hasPriceRange: ["ConfigurableProduct", "BundleProduct", "GroupedProduct"].includes(product.__typename)
  };
  return {
    ...product,
    cardProps
  };
};
export {
  prepareCardProduct
};
